const init = () => {
  document.querySelectorAll('.apts-clamp').forEach((box) => {
    const btn = box.nextElementSibling;
    if (!btn?.matches('.apts-clamp__toggle') || btn.dataset.ready) return;
    btn.dataset.ready = '1';
    const fit = () => {
      if (box.classList.contains('is-open')) return;
      const over = box.scrollHeight > box.clientHeight + 2;
      btn.hidden = !over;
      box.classList.toggle('is-clamped', over);
    };
    btn.addEventListener('click', () => {
      const open = box.classList.toggle('is-open');
      btn.textContent = open ? btn.dataset.less : btn.dataset.more;
      btn.setAttribute('aria-expanded', open);
      if (!open) box.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      fit();
    });
    new ResizeObserver(fit).observe(box);
    fit();
  });
};
init();
document.addEventListener('shopify:section:load', init);
